import api from './api';

export const genericList = async (codeType) => {
    let atividades = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        atividades = response.data.data;
    } catch (err) { }
    return atividades;
}

